import { Box, type BoxProps } from "@mantine/core"
import type { PropsWithChildren } from "react"
import classes from "./styles.module.css"

export function Sticky({ children, ...props }: PropsWithChildren<BoxProps>) {
  return (
    <Box className={classes.Sticky} {...props}>
      {children}
    </Box>
  )
}
